<template>
    <ListingModel category="ISSUE" />
</template>
<script>
import ListingModel from "@/views/Notification/Components/ListingModel.vue";

export default {
    name: "IssuePage",
    components: {ListingModel},
}
</script>

<style scoped>

</style>